import Config from "../../config/index";

const initialState = {
    isLoggedIn: true,
    email: 'info@awave.se',
    id: null,
    guid: null,
    userName: "",
    userId: "",
    firstName: null,
    lastName: null,
    jobTitle: '',
    role: "",
    actionSearchKeyword: "",
    managerId: null,
    manager: null,
    loading: false,
    submitting: false,
    users: [],
    ssoGetTokenLoading: false,
    ssoGetTokenFailed: false,
    ssoToken: "",
    hasOngoingActions: false
};

export default (state = initialState, action) => {

    switch (action.type) {

        case "USER_RESET":
            return initialState;

        case 'USER_SET_ROLE':

            let roleId = 0;
            switch (action.payload) {
                case "Hrbp":
                case "hrbp":
                    roleId = 4;
                    break;
                case "manager":
                    roleId = 2;
                    break;
                case "admin":
                    roleId = 3;
                    break;
                default:
                    roleId = 1;
                    break;
            }
            Config.setRole(roleId);
            state = {
                ...state,
                role: action.payload
            };
            return state;

        case 'USER_LOGIN_SUBMITTING':
            state = {
                ...state,
                submitting: true
            };
            return state;

        case 'USER_LOGIN_SUCCESS':
            Config.setUser({
                guid: action.payload.guid,
                userId: action.payload.userId,
                userName: action.payload.username,
            });

            Config.setUserLoggedInGuid({
                guid: action.payload.guid
            });

            state = {
                ...state,
                userName: action.payload.userName,
                userId: action.payload.userId,
                guid: action.payload.guid,
                isLoggedIn: true,
                submitting: false,
                loading: false
            };
            return state;

        case 'USER_LOGIN_FAILURE':
            state = {
                ...initialState,
                username: "",
                userId: "",
                isLoggedIn: false,
                submitting: false,
                loading: false
            };
            return state;

        case "USER_SET_ACTION_KEYWORD":
            state = {
                ...state,
                actionSearchKeyword: action.payload
            };
            return state;

        case 'USER_LOADING':
            state = {
                ...state,
                loading: true,
            }
            return state;

        case 'USER_SINGLE_SUCCESS':
        case "USER_SINGLE_DB_SUCCESS":

            Config.setUser({
                guid: action.payload.guid,
                userId: action.payload.userId,
                userName: action.payload.username,
            });

            state = {
                ...state,
                ...action.payload,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false,
                managers: null
            }
            return state;

        case 'USER_SINGLE_FAILURE':
        case "USER_SINGLE_DB_FAILURE":
            state = {
                ...state,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false
            };
            return state;

        case 'USER_GET_MANAGER':
            state = {
                ...state,
                manager: action.payload
            };
            return state;

        case 'USER_GET_ACTIONS':
            state = {
                ...state,
                actionGroups: action.payload
            };
            return state;

        case 'USER_GET_ONGOING_ACTIONS':
            state = {
                ...state,
                ongoingActions: action.payload
            };
            return state;

        case 'USER_FORMS_SUBMISSION_INPROGRESS':
            state = {
                ...state,
                submitting: true
            };
            return state;

        case 'USER_FORMS_SUBMISSION_FINISHED':
            state = {
                ...state,
                submitting: false
            };
            return state;

        case 'USER_FORMS_EXIT_ACTION':
            let ongoingActions = state.ongoingActions;
            let newSubmission = action.payload;
            let lastElement = state.ongoingActions[state.ongoingActions.length - 1];

            if (newSubmission.id) {
                for (let x in ongoingActions) {
                    if (ongoingActions[x].id === newSubmission.id) {
                        ongoingActions[x] = newSubmission;
                    }
                }
            } else {
                newSubmission.id = lastElement.id + 1;
                ongoingActions.push(newSubmission);
            }

            state = {
                ...state,
                submitting: false,
                ongoingActions: ongoingActions
            };
            return state;

        case 'USER_GET_ALL_USERS':
            state = {
                ...state,
                users: action.payload
            }
            return state;

        //---SSO-TOKEN
        case "SSO_GET_TOKEN_LOADING":
            state = {
                ...state,
                ssoGetTokenLoading: true,
                ssoTest: false,
                ssoGetTokenFailed: false
            };
            return state;

        case "SSO_GET_TOKEN_SUCCESS":
            state = {
                ...state,
                ssoGetTokenLoading: false,
                ssoToken: action.payload,
                ssoGetTokenFailed: false,
            };
            return state;

        case "SSO_GET_TOKEN_FAILURE":
            state = {
                ...state,
                ssoGetTokenLoading: false,
                ssoGetTokenFailed: true,
                ssoToken: false,
            };
            return state;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/user.js